var e={Trunk:"Trunk",Internal:"Internal",Mixed:"Mixed"};export{e as GasRouteType};
//# sourceMappingURL=types.js.map